export default function findLatest<T extends { version: number }>(input: T[]): T | undefined {
  return input.reduce((acc: T | undefined, next) => {
    return (acc?.version || 0) > next.version ? acc : next;
  }, undefined);
}
